export const products = [
  {
    id: 1,
    img: 'https://ppt.cc/fkgEYx@.png',
    link: 'https://adoring-davinci-ba5edb.netlify.app/',
    title: '電影搜尋(React)',
    desc: '',
  },
  {
    id: 2,
    img: 'https://ppt.cc/fvo2Zx@.png',
    link: 'https://salon.rocket-coding.com/#/',
    title: '美髮沙龍(Vue.js)',
    desc: '',
  },
];
